import React, { useState } from 'react';
import ClientesList from './ClientesList';
import ClienteForm from './ClienteForm';
import { Cliente } from '../../types';
import { API_CONFIG, buildApiUrl } from '../../config/api';

const Clientes: React.FC = () => {
  const [view, setView] = useState<'list' | 'form'>('list');
  const [selectedCliente, setSelectedCliente] = useState<Cliente | null>(null);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const handleEdit = (cliente: Cliente) => {
    setSelectedCliente(cliente);
    setView('form');
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm('¿Está seguro de que desea eliminar este cliente?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${buildApiUrl(API_CONFIG.CLIENTES.DELETE)}/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Error al eliminar el cliente');
      }

      setMessage({ type: 'success', text: 'Cliente eliminado exitosamente' });
      setTimeout(() => setMessage(null), 3000);
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error instanceof Error ? error.message : 'Error desconocido' 
      });
      setTimeout(() => setMessage(null), 5000);
    }
  };

  const handleSave = (cliente: Cliente) => {
    setMessage({ 
      type: 'success', 
      text: cliente.id ? 'Cliente actualizado exitosamente' : 'Cliente creado exitosamente' 
    });
    setTimeout(() => setMessage(null), 3000);
    setView('list');
    setSelectedCliente(null);
  };

  const handleCancel = () => {
    setView('list');
    setSelectedCliente(null);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Mensajes de estado */}
      {message && (
        <div className={`mb-4 p-4 rounded-lg ${
          message.type === 'success' 
            ? 'bg-green-100 border border-green-400 text-green-700' 
            : 'bg-red-100 border border-red-400 text-red-700'
        }`}>
          {message.text}
        </div>
      )}

      {/* Navegación */}
      {view === 'form' && (
        <div className="mb-6">
          <button
            onClick={handleCancel}
            className="flex items-center text-blue-600 hover:text-blue-800"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Volver al listado
          </button>
        </div>
      )}

      {/* Contenido principal */}
      {view === 'list' ? (
        <ClientesList onEdit={handleEdit} onDelete={handleDelete} />
      ) : (
        <ClienteForm 
          cliente={selectedCliente || {} as Cliente}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default Clientes; 